<template>
    <div class="td-search-popup" id="td-search-popup">
        <form action="/" class="search-form">
            <div class="form-group">
                <input type="text" class="form-control" placeholder="Search.....">
            </div>
            <button type="submit" class="submit-btn"><i class="fa fa-search"></i></button>
        </form>
    </div>
</template>

<script>
    export default {
        name: "SearchPopup",
        mounted() {
            const bodyOverlay = document.getElementById('body-overlay');
            const searchPopup = document.getElementById('td-search-popup');
            const searchButton = document.getElementById('search-bar-btn');

            bodyOverlay.addEventListener('click', function(){
                bodyOverlay.classList.remove('active');
                searchPopup.classList.remove('active');
            })

            searchButton.addEventListener('click', function(){
                searchPopup.classList.add('active');
                bodyOverlay.classList.add('active');
            })
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/SearchPopup.vue